/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiAddress, ApiContact, ApiImportExternalErpAddressRequest, ApiImportExternalErpContactsRequest } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ExternalErpAddressesController.
 */
export class ExternalErpAddressesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /external_erp/addresses:query
     */
    public getImportableAddressesPost(listRequest: ListRequest): Promise<Result<ListInfo<ApiAddress>>> {
        return this.http.post<Result<ListInfo<ApiAddress>>, ListRequest>('/external_erp/addresses:query', listRequest);
    }

    /**
     * Calls GET /external_erp/addresses:query
     */
    public getImportableAddressesGet(pageNo: number, pageSize: number): Promise<Result<ListInfo<ApiAddress>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);

        return this.http.get<Result<ListInfo<ApiAddress>>>('/external_erp/addresses:query', query);
    }

    /**
     * Calls POST /external_erp/addresses:import
     */
    public importAddressWithContacts(request: ApiImportExternalErpAddressRequest): Promise<Result<ApiAddress>> {
        return this.http.post<Result<ApiAddress>, ApiImportExternalErpAddressRequest>('/external_erp/addresses:import', request);
    }

    /**
     * Calls GET /external_erp/addresses/{externalAddressId}/contacts:query
     */
    public getImportableContacts(externalAddressId: string, pageNo: number, pageSize: number): Promise<Result<ListInfo<ApiContact>>> {
        const query = new URLSearchParams();
        query.set('externalAddressId', `${externalAddressId}`);
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);

        return this.http.get<Result<ListInfo<ApiContact>>>(`/external_erp/addresses/${externalAddressId}/contacts:query`, query);
    }

    /**
     * Calls POST /external_erp/addresses/{externalAddressId}/contacts:import
     */
    public importContacts(externalAddressId: string, request: ApiImportExternalErpContactsRequest): Promise<Result<boolean>> {
        const query = new URLSearchParams();
        query.set('externalAddressId', `${externalAddressId}`);

        return this.http.post<Result<boolean>, ApiImportExternalErpContactsRequest>(`/external_erp/addresses/${externalAddressId}/contacts:import`, request, query);
    }
}
